export function getDashboardTimeRanges() {
  let timeRanges = [];
  timeRanges.push({
    name: "Yesterday",
    id: 0,
    dName: "Dün"
  });
  timeRanges.push({
    name: "Today",
    id: 1,
    dName: "Bugün"
  });
  timeRanges.push({
    name: "Week",
    id: 2,
    dName: "Bu hafta"
  });
  timeRanges.push({
    name: "Month",
    id: 3,
    dName: "Bu Ay"
  });
  timeRanges.push({
    name: "Year",
    id: 4,
    dName: "Bu Yıl"
  });
  return timeRanges;
}

export function getDaysOfWeek() {
  let days = [];
  days.push({
    id: 0,
    name: "Pazar"
  });
  days.push({
    id: 1,
    name: "Pazartesi"
  });
  days.push({
    id: 2,
    name: "Salı"
  });
  days.push({
    id: 3,
    name: "Çarşamba"
  });
  days.push({
    id: 4,
    name: "Perşembe"
  });
  days.push({
    id: 5,
    name: "Cuma"
  });
  days.push({
    id: 6,
    name: "Cumartesi"
  });
  return days;
}

export function getDashboardProps() {
  let types = [];
  types.push({
    name: "Amount",
    id: 0,
    dName: "Ciroya Göre"
  });
  types.push({
    name: "Piece",
    id: 1,
    dName: "Adete Göre"
  });
  types.push({
    name: "Cost",
    id: 2,
    dName: "Maaliyete Göre"
  });
  types.push({
    name: "Profit",
    id: 3,
    dName: "Kar'a Göre"
  });
  return types;
}

export function getSortDirections() {
  let directions = [];
  directions.push({
    name: "Asc",
    id: 0,
    dName: "Artan"
  });
  directions.push({
    name: "Desc",
    id: 1,
    dName: "Azalan"
  });
  return directions;
}

export function getReportTypes() {
  let types = [];
  types.push({
    name: 'Category',
    id: 2,
    dName: 'Kategori'
  });
  types.push({
    name: 'Product',
    id: 1,
    dName: 'Ürün'
  });
  return types;
}
